import { Show, splitProps } from "solid-js";
import type { JSX } from "solid-js";

interface Props {
    label: string;
    checked: boolean;
    onChange: (next: boolean) => void;
    hint?: string;
    disabled?: boolean;
    /** id pra label clicável + aria */
    id?: string;
}

/**
 * Switch acessível -- substitui checkbox raw em settings/admin.
 * Visual: pista cinza/laranja + bolinha branca animada.
 * Acessível: keyboard (space toggle) + aria-checked.
 */
export function Toggle(allProps: Props & { class?: string }) {
    const [own, rest] = splitProps(allProps, [
        "label",
        "checked",
        "onChange",
        "hint",
        "disabled",
        "id",
        "class",
    ]);
    const id = own.id ?? `toggle-${Math.random().toString(36).slice(2, 9)}`;

    function handleKey(e: KeyboardEvent & { currentTarget: HTMLDivElement }) {
        if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            if (!own.disabled) own.onChange(!own.checked);
        }
    }

    return (
        <div class={`ui-toggle-row ${own.class ?? ""}`} {...(rest as JSX.HTMLAttributes<HTMLDivElement>)}>
            <div
                role="switch"
                aria-checked={own.checked}
                aria-labelledby={`${id}-label`}
                aria-disabled={own.disabled}
                tabindex={own.disabled ? -1 : 0}
                class={`ui-toggle ${own.checked ? "is-on" : ""} ${own.disabled ? "is-disabled" : ""}`}
                onClick={() => !own.disabled && own.onChange(!own.checked)}
                onKeyDown={handleKey}
            >
                <span class="ui-toggle-thumb" aria-hidden="true" />
            </div>
            <label for={id} id={`${id}-label`} class="ui-toggle-info" onClick={() => !own.disabled && own.onChange(!own.checked)}>
                <strong>{own.label}</strong>
                <Show when={own.hint}>
                    <span>{own.hint}</span>
                </Show>
            </label>
        </div>
    );
}
